
const createrole = {
  label: "Create Role",
  pageLabel: "Create Role",
  starting: true,
  url: "createrole",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Role",
      label: "Role",
      name: "role",
      description: "Enter Role"
    },

    {
      inputType: "text",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "role",
      description: ""
    },
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Description",
      label: "Description",
      name: "Description",
      description: "Enter Description"
    },
    {
      inputType: "text",
      isRequired: true,
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Description",
      name: "Description",
      description: "Enter Description"
    },
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Search",
      label: "Search",
      name: "Search",
      description: "Enter Search"
    },
    {
      inputType: "text",
      isRequired: true,
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Search",
      name: "Search",
      description: "Enter Search"
    },
    {
      inputType: "displaytext",
      isRequired: true,
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "Supper User",
      label: "Supper User",
      name: "Supper_User",
      description: "Supper User"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "Default Roles Only",
      label: "Default Roles Only",
      name: "Default_Role",
      description: "Default Roles Only"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "Allow Cash Transactions ",
      label: "Allow Cash Transactions",
      name: "Allow_Cash",
      description: "Allow Cash Transactions"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "Main Cashier",
      label: "Main Cashier",
      name: "Main_Cashier",
      description: "Main Cashier"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "Allow All Domain",
      label: "Allow All Domain",
      name: "Allow_Domain",
      description: "Allow All Domain"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "Allow for Region",
      label: "Allow for Region",
      name: "Allow_Region",
      description: "Allow for Region"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "Active",
      description: "Active"
    }
  ]
};
export default createrole;
